import script from "./ExchangeRate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExchangeRate.vue?vue&type=script&setup=true&lang=ts"

import "./ExchangeRate.vue?vue&type=style&index=0&id=61744658&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61744658"]])

export default __exports__